import { ActionContext } from 'vuex';
import {ListStateItem, ListModuleItem} from '@/store/shared/index'
import Income from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';
import IncomeDetail from '../incomedetail/entity';

//定义 interface  常用情况 edit页面entity  codelist等   页面需要的数据对象都要在此声明
interface IncomeState extends ListStateItem<Income>{
    editIncome: Income;
    editDetail: IncomeDetail;
}

class IncomeModule extends ListModuleItem<IncomeState,any,Income>{

    //构造函数 （必须）将派生类中 的overrideState 和 overrideMutations 与基类（ListModuleItem）中的state mutations合并
    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }
    
    //state  页面需要的数据对象都要在此实例化  
    overrideState = {
       editIncome: new Income(),
       editDetail: new IncomeDetail()
    }

    //action中 function 都是异步
    actions = {
        //分页查询
        async getAll(context: ActionContext<IncomeState, any>, payload: any) { 
            context.state.table.loading=true;
            let reponse = await $http.get('services/app/Income/GetAll', { params: payload.data });
            context.state.table.loading=false;
            let page = reponse.data.result as PageResult<Income>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        //根据DeclareCustomsId获取单个记录
        async getByDeclareCustomsId(context: ActionContext<IncomeState, any>, payload: any) {
            let reponse = await $http.get('/services/app/Income/GetByDeclareCustomsId?declareCustomsId=' + payload.declareCustomsId);
            context.state.editIncome = reponse.data.result as Income;
        },
        //保存收汇
        async save(context: ActionContext<IncomeState, any>, payload: any) {
            await $http.post('services/app/Income/Save', payload.data);
        },
        //已全部收汇
        async confirm(context: ActionContext<IncomeState, any>, payload: any) {
            await $http.post('services/app/Income/Confirm', payload.data);
        },
        //收汇解锁
        async unlock(context: ActionContext<IncomeState, any>, payload: any) {            
            return await $http.post('services/app/Income/Unlock', payload);
        },
    };

    overrideMutations = {
        editDetail(state: IncomeState, incomeDetail: IncomeDetail) {
            state.editDetail = incomeDetail;
        }
    }
}

const incomeModule = new IncomeModule();
export default incomeModule;
